import { render, staticRenderFns } from "./ArchiveCategoryPage.vue?vue&type=template&id=6e70ae3c"
import script from "./ArchiveCategoryPage.vue?vue&type=script&lang=js"
export * from "./ArchiveCategoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports